// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear[data-v-484dd484],\n.search[data-v-484dd484] {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
